import React, { Component } from 'react';
import ReactSpeedometer from "react-d3-speedometer"; 
import hjorringLogo from '../../images/hjorring-by-logo-100.png';

import DesktopBreakpoint from './responsive_utilities/desktop_breakpoint';
import TabletBreakpoint from './responsive_utilities/tablet_breakpoint';
import PhoneBreakpoint from './responsive_utilities/phone_breakpoint';
import SmallPhoneBreakpoint from './responsive_utilities/small_phone_breakpoint';

const url = 'http://gvm.itoperators.dk:5006/api/consumer';

export default class GvConsumerSpeedometer extends Component {
  static propTypes = {

  };

  state = {
    Reading: [],
    CurrentLiveApplier: 'plus',
    formatedValue: 0
  };

  componentDidMount() {
    this.fetchConsumerData();
    this.timerID = setInterval(
      () => this.fetchConsumerData(),
      2500
    );
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  fetchConsumerData = async () => {
    if(this.state.CurrentLiveApplier === 'plus') {
          this.setState({CurrentLiveApplier: 'minus'})
      } else {
          this.setState({CurrentLiveApplier: 'plus'})
      }
    await fetch(url, {
      method: 'GET',
      headers: new Headers({
        'ID': '1',
        'Content-Type': 'application/json',
        'Key' : 'ConsumerRecent'
      })
    })
      .then(Response => Response.json())
      .then(data => {
        this.setState({ Reading: data })
    });
  }

  round(value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
  }

  getRandom() {
    const min = 10;
    const max = 100;
    return min + Math.random() * (max - min);
  }

  render() {

    let ReadingValue = this.round(this.state.Reading.value*1000,1);

    if(isNaN(ReadingValue)) {
      ReadingValue = 15000;
    }
    if(this.state.CurrentLiveApplier === 'plus') {
      ReadingValue = ReadingValue + this.round(this.getRandom(), 1);      
    }
    else {
      ReadingValue = ReadingValue - this.round(this.getRandom(), 1);      
    }

    let formattedValue = new Intl.NumberFormat('de-DE').format(ReadingValue);

    return (
      <div>        
        <img src={hjorringLogo} alt="" />  
        <DesktopBreakpoint>
          <ReactSpeedometer
                  foreceRender={true}    
                  width={500}
                  height={280} 
                  maxValue={30000}
                  value={ReadingValue}
                  needleColor="#2A3539"
                  startColor="#ff7c7c"
                  maxSegmentLabels={8}
                  segments={1000}
                  endColor="#ff0000"
                  currentValueText={"kW : " + formattedValue}
                  needleTransitionDuration={5000}
                  needleTransition="easeElastic"
              />
          </DesktopBreakpoint>

        <TabletBreakpoint>
          <ReactSpeedometer
                  foreceRender={true}    
                  width={400}
                  height={230} 
                  maxValue={30000}
                  value={ReadingValue}
                  needleColor="#2A3539"
                  startColor="#ff7c7c"
                  maxSegmentLabels={8}
                  segments={1000}
                  endColor="#ff0000"
                  currentValueText={"kW : " + formattedValue}
                  needleTransitionDuration={5000}
                  needleTransition="easeElastic"
              />
          </TabletBreakpoint>


        <PhoneBreakpoint>
          <ReactSpeedometer
                  foreceRender={true}    
                  width={300}
                  height={180} 
                  maxValue={30000}
                  value={ReadingValue}
                  needleColor="#2A3539"
                  startColor="#ff7c7c"
                  maxSegmentLabels={8}
                  segments={1000}
                  endColor="#ff0000"
                  currentValueText={"kW : " + formattedValue}
                  needleTransitionDuration={5000}
                  needleTransition="easeElastic"
              />
          </PhoneBreakpoint>

          <SmallPhoneBreakpoint>
            <ReactSpeedometer
                    foreceRender={true}    
                    width={300}
                    height={180} 
                    maxValue={30000}
                    value={ReadingValue}
                    needleColor="#2A3539"
                    startColor="#ff7c7c"
                    maxSegmentLabels={8}
                    segments={1000}
                    endColor="#ff0000"
                    currentValueText={"kW : " + formattedValue}
                    needleTransitionDuration={5000}
                    needleTransition="easeElastic"
                />
          </SmallPhoneBreakpoint>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/GvConsumerSpeedometer.js